import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";
import { SITE } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogDetailPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  usePageMeta(post?.title || "Article", post?.excerpt);

  useEffect(() => {
    axios.get(`${API}/posts/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <>
        <Header />
        <main className="min-h-screen flex items-center justify-center bg-black pt-24">
          <div className="text-center">
            <h1 className="font-display text-5xl text-white">Article not found</h1>
            <Link to="/blog" className="mt-6 inline-block px-6 py-3 rounded-full bg-brand-yellow text-black font-black uppercase text-sm tracking-wider">Back to blog</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }
  if (!post) return <><Header /><main className="min-h-screen bg-black" /><Footer /></>;

  return (
    <>
      <Header />
      <main>
        <section className="relative pt-32 pb-12 bg-black">
          <div className="absolute inset-0">
            <img src={post.cover_image || SITE.classImg7} alt="" className="w-full h-full object-cover opacity-25" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black to-black" />
          </div>
          <div className="relative max-w-3xl mx-auto px-6 sm:px-8">
            <Link to="/blog" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-brand-yellow mb-5"><ArrowLeft size={14} /> All articles</Link>
            <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-400 mb-3">
              {post.author} · {new Date(post.created_at).toLocaleDateString()}
            </div>
            <h1 className="font-display text-5xl sm:text-6xl text-white tracking-wide leading-[0.95]">{post.title}</h1>
            <p className="mt-5 text-lg text-zinc-300">{post.excerpt}</p>
          </div>
        </section>
        <article className="py-12 sm:py-16 bg-black">
          <div className="max-w-3xl mx-auto px-6 sm:px-8">
            <p className="text-lg text-zinc-200 leading-relaxed whitespace-pre-line">{post.body}</p>
            <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row gap-3">
              <Link to="/journey" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-brand-yellow text-black font-black uppercase text-sm tracking-wider hover:bg-brand-yellowHover transition-all">Start Your Journey</Link>
              <Link to="/blog" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-white/20 text-white font-bold uppercase text-sm tracking-wider hover:bg-white hover:text-black transition-all">More articles</Link>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}
